import type {
  HubStorageCapacity,
  HubStorageCapacityServiceId,
} from '@robovision/hub'
import { HubStorageCapacityStatus } from '@robovision/hub'
import { formatBytes } from '@robovision/rvai-utils'


interface StorageCapacityParams {
  deviceId: number
  serviceId: HubStorageCapacityServiceId
  status: HubStorageCapacityStatus
  totalInodes: number
  totalSize: number
  updatedAt: Date
  usedInodes: number
  usedSize: number
}

export class StorageCapacity {
  public deviceId: number
  public serviceId: HubStorageCapacityServiceId
  public status: HubStorageCapacityStatus
  public totalInodes: number
  public totalSize: number
  public updatedAt: Date
  public usedInodes: number
  public usedSize: number

  constructor (params: StorageCapacityParams) {
    this.deviceId = params.deviceId
    this.serviceId = params.serviceId
    this.status = params.status
    this.totalInodes = params.totalInodes
    this.totalSize = params.totalSize
    this.updatedAt = params.updatedAt
    this.usedInodes = params.usedInodes
    this.usedSize = params.usedSize
  }

  public get totalSizeReadable (): string {
    return formatBytes(this.totalSize)
  }

  public get usedSizeReadable (): string {
    return formatBytes(this.usedSize)
  }

  public static fromResponse (data: HubStorageCapacity): StorageCapacity {
    return new StorageCapacity({
      deviceId: data.deviceId,
      serviceId: data.serviceId,
      status: data.status,
      totalInodes: data.totalInodes,
      totalSize: data.totalSize,
      updatedAt: new Date(data.updatedAt),
      usedInodes: data.usedInodes,
      usedSize: data.usedSize,
    })
  }
}
